export default "__VITE_ASSET__9446ec48__"